<template>
  <div>
    <h4 class="text-slate-900 font-bold text-lg">Users and Permissions</h4>

    <BaseTable
      :is-loading="isPending"
      :items="users ?? []"
      :fields="tableFields"
      :paginate="true"
      :next-page="nextPage"
      :prev-page="prevPage"
      :page="currentPage"
      :total-records="totalRecords"
      :total-pages="totalPageCount"
      :number-per-page="numPerPage"
      :clickable="true"
      class="-ml-4"
      @row-selected="onRowSelected"
    >
      <template #name-data="data">
        <span class="font-semibold text-slate-950">{{ data.row.name }}</span>
      </template>
    </BaseTable>
  </div>
</template>

<script lang="ts" setup>
import BaseTable from '@/components/base/BaseTable.vue'
import { usePaginatableService } from '@/services/PaginatableService'
import UserService from '@/services/UserService'
import { useQuery, useQueryClient } from '@tanstack/vue-query'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const tableFields = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'type', label: 'Type', sortable: true },
  { key: 'email', label: 'Email'},
]

const queryClient = useQueryClient()
const userService = new UserService()
const numPerPage = ref(25)
const {
  fetcher,
  currentPage,
  totalPageCount,
  totalRecords,
  nextPage,
  prevPage,
} = usePaginatableService(userService, { numPerPage: numPerPage.value, orderByField: 'name', orderByDirection: 'asc' })

const { data: users, isPending } = useQuery({
  queryKey: ['user', currentPage],
  queryFn: async () => {
    const { data } = await fetcher()

    // create a detail cache for each item
    data.forEach((user: any) => {
      queryClient.setQueryData(['user', user.id], user)
    })

    return data
  }
})

const $router = useRouter()
const onRowSelected = (row: any) => {
  $router.push({ name: 'EditUser', params: { uid: row.id } })
}

</script>
